import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'xn-dropdown',
  standalone: false,
  templateUrl: './dropdown.html',
  styleUrl: './dropdown.sass',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => Dropdown),
      multi: true
    }
  ]
})
export class Dropdown implements ControlValueAccessor {
  @Input('options') options: any[] = [];
  @Input('autoDisplayFirst') autoDisplayFirst = false;
  @Input('optionLabel') optionLabel?: string = '';
  @Input('optionValue') optionValue?: string = '';
  @Input('styleClass') styleClass: string = '';
  @Input('placeholder') placeholder?: string = '';
  @Input('filterBy') filterBy: string = '';
  @Input('readonly') readonly?: boolean = false;
  @Input('filter') filter: boolean = false;
  @Input('group') group: boolean = false;
  @Input('virtualScroll') virtualScroll: boolean = false;
  @Input('filterPlaceholder') filterPlaceholder?: string = '';

   _value: any;

  writeValue(value: any): void {
    this._value = value;
  }

  propagateChange = (_: any) => {

  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
    
  }

  setDisabledState?(isDisabled: boolean): void {
    
  }

  _onValueChange(event: any){
    this._value = event;
    this.propagateChange(event);
  }

  show(){

  }
}
